import { ComponentAPI } from '@philips-internal/oswald-ui-core';
export default class TeleconsultattionApi extends ComponentAPI {
    setCallbackUrl(url) {
        this.setState({ url });
        if (url) {
            this.setState({ closed: false, showFrame: true });
        }
    }
}
//# sourceMappingURL=teleconsultation-api.js.map